import React from "react";
// import Progress from "../Progress";
import SubmitButton from "../../Buttons/SubmitButton";
import BackIconWhite from "../../../assets/images/BackIconWhite.svg";
import loginEnvMap from "../../../config.js";

export const SomethingWrong = () => {
  const handleLogin = () => {
    const env = (window.env || "").toLowerCase();
    const apiUrl = process.env.REACT_APP_API_URL;
    const loginUrl = apiUrl ? `${apiUrl}/saml/login` : "/api/saml/login";
    window.location.href = loginEnvMap[env] || loginUrl;
  };
  return (
    <>
      <div className="intro">
        {/* <Progress progress={40} /> */}
        <h1 className="intro-title-mi" lang="mi-NZ">
          Auē, i hē tētahi mea
        </h1>
        <hr />
        <h1 className="intro-title"> Oops, something went wrong </h1>

        <div className="step-container">
          <p className="mb-4">
            It looks like we're having some trouble right now. Please try
            completing your application later.
          </p>
        </div>
        <div className="step-button-container">
          <SubmitButton
            text={"Back to RealMe"}
            onClick={handleLogin}
            Icon={BackIconWhite}
          />
        </div>
      </div>
    </>
  );
};

export default SomethingWrong;
